<div class="main-container">

    <div class="header-container">
        <div><p class="history-heading-gridding">Gridding Timeline View</p></div>
        <div class="close-icon-container-gridding"><img src="../../../assets/icons/close.svg" alt="Icon description" class="close-icon-gridding" (click)="onCloseClick()"></div>
    </div>

    <div class="secondary-container">
        <div class="type-quick-filter-container">
            <mat-button-toggle-group #typeGroup="matButtonToggleGroup" class="toggle-group-container-gridding" [value]="selectedAnalysisType" (change)="clickType(typeGroup.value)">
                <mat-button-toggle class="type-filter-btn-gridding-all" value="ALL">All</mat-button-toggle>
                <mat-button-toggle class="type-filter-btn-gridding" value="CHEMICAL - TOP SOIL">Chemical - Top Soil</mat-button-toggle>
                <mat-button-toggle class="type-filter-btn-gridding" value="CHEMICAL - SUB SOIL">Chemical - Sub Soil</mat-button-toggle>
            </mat-button-toggle-group>

    </div>


    <div style="width: 62%; height: 50px;"></div>
    
        <div class="downloads-container">
                    <mat-accordion class="gridding-downloads-btn">
                        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                            <mat-expansion-panel-header>
                                <mat-panel-title class="gridding-downloads-btn-text" style="font-size: 15px;">
                                    Export
                                </mat-panel-title>
                            </mat-expansion-panel-header>

                            <div (click)="exportGriddingAsExcel()" class="download-container">
                                <div type="button" class="downloads-option-text-container">
                                    <p class="gridding-downloads-option-text text-no-margin">Excel</p>
                                    <img src="../../../assets/icons/download.svg" alt="Download Icon" class="gridding-downloadPDF-icon">
                                </div>
                            </div>
                        </mat-expansion-panel>
                    </mat-accordion>
                </div>
        </div>

            <div class="griding-timeline-container">
                <div class="timeline-heading"><p class="text-no-margin">Farm/Field</p></div>

                @for(date of tenYearPeriod; track date) {
                <div class="timeline-heading">
                    <p class="text-no-margin">{{date}}</p>
                </div>
                }
                @empty{
                    <div class="timeline-heading">
                        <p class="text-no-margin">no date</p>
                    </div>
                }
                
                <div class="timeline-heading"><p class="text-no-margin">Years Since Last Analysis</p></div>
            </div>

            <div class="gridding-dates-main-container">

        <div>
            @for(farm of groupedGriddingData; track farm.farm_id) {
            <mat-expansion-panel class="farm-container-gridding gridding-view-custom">
                <mat-expansion-panel-header>
                    <mat-panel-title class="farm-header-gridding">
                            <p class="farm-header-gridding-text">{{farm.farmName}}</p>
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <div class="">
                    @for(field of farm.fields; track field.field_id) {
                        <div class="griding-timeline-container-field-dates" [ngClass]="getStatusClass(field.status)">
                            <div class="timeline-dates"><p class="text-no-margin timeline-bold-text">{{field.field_name}}</p></div>
                            @for(year of tenYearPeriod; track year) {
                                <div class="timeline-dates"><p class="text-no-margin timeline-text">{{matchDateToYear(field, year)}}</p></div>
                            }
                            <div class="timeline-dates"><p class="text-no-margin timeline-bold-text">{{field.status}}</p></div>
                        </div>
                    }
                    @empty {
                        <p>No fields available</p>
                    }

                    <div class="griding-timeline-container-field-dates row-hectares-total">
                        <div class="timeline-dates"><p class="text-no-margin timeline-bold-text">Totals :</p></div>
                        @for(year of tenYearPeriod; track year) {
                            <div class="timeline-dates"><p class="text-no-margin timeline-bold-text">{{calculateGriddingHectaresPerYear(farm, year)}} ha</p></div>
                        }
                        <div class="timeline-dates"><p class="text-no-margin timeline-bold-text"></p></div>
                    </div>
                </div>
            </mat-expansion-panel>
            }
            @empty {
                <div class="gridding-no-items-message-container">
                    <div class="gridding-no-items-message">Sorry! No items found within the selected filter range.</div>
                </div>
            }
        </div>

            </div>
</div>















